import { debug } from 'application/Shared/Utils';
import Cookies from 'js-cookie';

export const prefix = 'feature';

// get flags from URL
export const getURLFeatureFlags = () => {
    const params = new URLSearchParams(window.location.search);
    const found = params.get(prefix)?.split(',') || [];
    return found.reduce((all, current) => {
        const [label, enabled, data] = current.split(':');
        if (all.find((f) => f.label === label)) return all;
        return [
            ...all,
            { data, enabled: enabled ? /true/i.test(enabled) : true, label }
        ];
    }, []);
};

// local feature toggles state
export const saveFeatures = (features) =>
    Cookies.set(prefix, JSON.stringify(features));

export const getFeatures = () => {
    try {
        const found = JSON.parse(Cookies.get(prefix) || '{}');
        const urlFlags = getURLFeatureFlags();
        if (urlFlags.length > 0) {
            urlFlags.forEach(({ label, enabled }) => {
                found[label] = enabled;
            });
            saveFeatures(found);
        }
        return found;
    } catch (e) {
        debug.e('error parsing feature flags', e);
        return {};
    }
};

export const getFeatureData = (label) =>
    getURLFeatureFlags().find(
        (featureFlag) => featureFlag.label === label && featureFlag.enabled
    )?.data;

export const setFeature = (feature) => {
    const features = getFeatures();
    features[feature.label] = feature.enabled;
    saveFeatures(features);
};

/**
 * Function that determines whether the URL has a specific feature flag set or not
 * @param {string} label - feature flag name
 *
 * @returns {boolean}
 */
export const hasFeature = (label) => getFeatures()[label];

export const enableFeature = (label) => setFeature({ enabled: true, label });

export const disableFeature = (label) => setFeature({ enabled: false, label });

export const deleteFeature = (label) => {
    const features = getFeatures();
    delete features[label];
    saveFeatures(features);
};
